<el-main class="main">
  <div class="form">

    <el-form
      class="module"
      label-position="top"
      ref="ruleFormRef"
      :model="ruleForm"
      :rules="rules"
    >
      <h1 class="calculator__title content-padding" v-show="dataForm.isOrderDone == false" data-title="{{dataForm.pageTitle}}" data-sendtitle="{{dataForm.pageSendTitle}}">{{(formTabs.activeName != formTabs.tabs.slice(-1)[0]) ? dataForm.pageTitle : "Проверить данные перевозки"}}</h1>
      <el-tabs v-model="formTabs.activeName" class="demo-tabs" v-show="dataForm.isOrderDone == false">
        <el-tab-pane
          label="Данные контрагентов"
          name="services"
        >
          <div class="tab-container calculator__inner calc-vlayout-1">
            <SenderPartialCutter
              :citiesFrom="citiesFrom"
              :citiesTo="citiesTo"
              @click-button-back="clickFormButtonBack"
            />
            <CargoInformationPartial
              @click-button-back="clickFormButtonBack"
              @click-button-next="clickFormButtonNext"
              @count-all="calculatePackage"
              @check-first-page="clickForFirstPage"
            />
            <!-- <ConsigneePartial :cities="cities" />
            <ThirdPersonPartial
              @click-button-back="clickFormButtonBack"
              @click-button-next="clickFormButtonNext"
            /> -->
          </div>
        </el-tab-pane>
        <el-tab-pane
          label="Информация о заборе/доставке"
          name="cargo-transportation-customer"
          class="calc-step-3 calculator"
        >
          <div class="tab-container calculator__inner">
            <SenderPartial
            :cities="cities"
            />
            <ConsigneePartial :cities="cities" />
            <ThirdPersonPartial
              @click-button-back="clickFormButtonBack"
              @click-button-next="clickFormButtonNext"
            />
          </div>
        </el-tab-pane>
        <el-tab-pane label="Информация о грузе" name="payment" class="calc-step-4 calculator">
          <div class="tab-container calculator__inner" style="max-width: 1260px; flex-wrap: wrap;">
            <PaymentPartial
              @click-button-back="clickFormButtonBack"
              @click-button-next="clickFormButtonNext"
            />
          </div>
          
        </el-tab-pane>
        <el-tab-pane label="Доп. услуги" name="application-cargo-pickup" class="calc-step-5 calculator">
          <ApplicationCargoPickupPartial
            @click-button-back="clickFormButtonBack"
            @click-button-next="clickFormButtonNext"
          />
        </el-tab-pane>
        <el-tab-pane label="СМС информирование" name="application-sms-inform" class="calc-step-5-5 calculator" v-if="dataForm.getSmsTabEnabled">
          <ApplicationSMSInform
            @click-button-back="clickFormButtonBack"
            @click-button-next="clickFormButtonNext"
          />
        </el-tab-pane>
        <el-tab-pane label="Оплата" name="cargo-information" class="calc-step-6 calculator">
          <div class="tab-container calculator__inner">
            <PaymentPartialAgree
              @click-button-back="clickFormButtonBack"
              @submit-form-sender="submitFormSender"
              :ruleFormRef="ruleFormRef"
            />
          </div>
        </el-tab-pane>
      </el-tabs>
      <el-dialog custom-class="tk-dialog tk-dialog-big" v-model="dataForm.decalreWindowShow" :show-close="false" width="500">
        <template #header="{ close, titleId, titleClass }">
        <div class="my-header">
            <h4 :id="titleId" :class="titleClass" class="break-word">Объявленная стоимость</h4>
        </div>
        </template>
        <div class="dialog-text">
        Вы можете указать действительную стоимость груза.<br>Подтверждая 3000₽, вы отказываетесь от её указания и выбираете объявленную ценность груза 3000₽.
        <div class="order-creation-form__fields note-message-banner message">
            <div class="note-message-banner__text">
                <div class="note-message-banner__description">При утрате, недостаче или повреждении груза размер возмещения реального ущерба определяется исходя из объявленной ценности.</div>
            </div>
        </div>
        </div>
        <div class="action-line">
          <button class="el-button el-button--secondary m-err close-button" type="button" @click="dataForm.decalreWindowShow = false"><span class="">Указать другую<br>ценность</span></button>
          <button class="el-button el-button--secondary m-err close-button" type="button" @click="dataForm.decalreWindowShow = false; dataForm.sender.first_step_pass = true;"><span class="">Подтверждаю 3000₽</span></button>
        </div>
    </el-dialog>
      <el-dialog
        
        title="Уважаемый клиент!"
        class="dialog"
        center
      >
        <div class="print-container">
          <template v-if="alertOfApplicationSubmission.pickupDate">
            <span class="span_padding-bottom--8px"
              >От Вас поступила заявка на забор груза</span
            >
            <span class="span_padding-bottom--8px"
              ><strong
                >№{{ alertOfApplicationSubmission.numberApplication }}</strong
              ></span
            >

            <span class="span_padding-bottom--8px"
              >Курьер подъедет в указанное Вами время:</span
            >
            <span class="span_padding-bottom--8px"
              >{{ alertOfApplicationSubmission.pickupDate }}</span
            >
            <span class="span_padding-bottom--8px"
              >с {{ alertOfApplicationSubmission.cargoStartTimePickup }} до {{
              alertOfApplicationSubmission.cargoEndTimePickup }}</span
            >

            <span>Просьба упаковать, промаркировать груз перед отправкой и распечатать экспедиторскую расписку для курьера!</span>
          </template>

          <template v-else>
            <span class="span_padding-bottom--8px"
              >Вами сформирована экспедиторская расписка</span
            >
            <span class="span_padding-bottom--8px"
              ><strong
                >№{{ alertOfApplicationSubmission.numberApplication }}</strong
              ></span
            >
            <span class="span_padding-bottom--8px"
              >От {{ alertOfApplicationSubmission.createTime.day }}/{{ parseDate(Number(alertOfApplicationSubmission.createTime.month) + 1) }}/{{ alertOfApplicationSubmission.createTime.year }}</span>

            <span
              >Продиктуйте последние 7 цифр на приёмке склада при сдаче
              груза</span
            >
          </template>
        </div>
        <template #footer>
          <el-button
            class="button__send"
            @click="onPrint"
            type="primary"
            :icon="Printer"
            >Печать экспедиторской расписки</el-button
          >
          <el-button
            class="button__send"
            @click="onPrintTalons"
            type="primary"
            :icon="Printer"
            >Печать маркировочных талонов</el-button
          >
        </template>
      </el-dialog>
      <div class="result-frames__wrapper" v-show="dataForm.isOrderDone == false">
        <PackageDistanation/>
        <CalculatedResult/>
      </div>
      <div v-show="dataForm.isOrderDone == true" class="calculator__inner calculator__inner_shadow_unset">
        <FinishFrame 
          :alertOfApplicationSubmission = "alertOfApplicationSubmission" 
          @onPrint="onPrint"
          @onPrintTalons="onPrintTalons"
        />
      </div>
    </el-form>
  </div>
</el-main>
